export var EField;
(function (EField) {
    EField["Captcha"] = "captcha";
    EField["Token"] = "token";
})(EField || (EField = {}));
